/* eslint-disable no-ternary */
/* eslint-disable vars-on-top */
/* eslint-disable one-var */
(function() {
  'use strict';

  function toggleButtons(button) {
      var parent = button.parentNode,
          isExpanded = button.getAttribute('aria-expanded') === 'true';

      button.classList.toggle('is-active');
      parent.classList.toggle('toon-meer');
      button.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');

      // select all new shown buttons after trigger
      var newButtons = parent.querySelectorAll('.bigbutton:not(.is-shown)');

      // Set focus on first new shown button
      if (newButtons.length > 0) {
          newButtons[0].focus();
      }
  }

  function addButtonListeners() {
      var bigButtons = document.querySelectorAll('.js-meer-bigbuttons');

      bigButtons.forEach(function(button) {
          button.addEventListener('click', function() {
              toggleButtons(this);
          });
      });
  }

  addButtonListeners();
})();
